import { Checkbox, Money, Text } from '@belong/ui';
import type { GroupedBalancesInfoModel } from 'api/models.v2';
import {
  getBalanceSubtitle,
  getBalanceSubtitleStyles,
} from 'pages/Accounts/utils/get-balance-subtitle';

type SelectableBalanceProps = {
  balance: GroupedBalancesInfoModel;
  isSelected: boolean;
  onToggle: (balance: GroupedBalancesInfoModel) => void;
};

export function SelectableBalance({
  balance,
  isSelected,
  onToggle,
}: SelectableBalanceProps) {
  const subtitle = getBalanceSubtitle(balance);
  const subtitleStyles = getBalanceSubtitleStyles(balance.billStatusInfo);

  return (
    <div className="flex items-center justify-between rounded-small border border-light-gray py-xs">
      <div className="flex flex-1 flex-col">
        <Checkbox
          id={`balance-${balance.groupBalanceItemId}`}
          checked={isSelected}
          label={balance.description || ''}
          onChange={() => onToggle(balance)}
        />
        {subtitle && (
          <div className="pl-[28px]">
            <Text variant="p1" className={subtitleStyles}>
              {subtitle}
            </Text>
          </div>
        )}
      </div>
      <Money
        value={Math.abs(balance.netBalance || 0)}
        format="DOLLARS_WITH_CENTS"
        className="text-body font-semibold"
      />
    </div>
  );
}
